import { render, staticRenderFns } from "./NewNewsletterView.vue?vue&type=template&id=5d1b5167"
import script from "./NewNewsletterView.vue?vue&type=script&lang=js"
export * from "./NewNewsletterView.vue?vue&type=script&lang=js"
import style0 from "./NewNewsletterView.vue?vue&type=style&index=0&id=5d1b5167&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports